<template>
  <div class="power-switch-page"
  >
  <div class="bodybox">
      <div class="leftbox">
           <div id="data-view">
        <div>{{ nowStatus }}</div>
            <div class="main-plugin" style="width: 512px;height: 288px;margin-left: 30px;">
            <img :src="canvasImageBackGround"  v-if="canvasImageBackGround"  alt="MQTT Image" style="width:100%;height: 100%;object-fit: contain;" />

            <div class="main-canvas">
             <canvas ref="posiToShape" id="posiToShape" width="512" height="288" ></canvas>
            </div>
            <!-- <canvas id="posiToShape" width="512" height="288"  ></canvas> -->
            </div>
     
       
      </div>
    </div>
     <div class="rightbox">
      <div style="color: #fff;font-size: 10px;">
        实况两分钟后自动关闭，重新进入
      </div>
                <div class="device-select-row">
            <el-select
              v-model="selectedTimerDevice"
              placeholder="请选择设备"
              size="mini"
              style="width: 160px;"
              value-key="deviceId"
              @change="deviceListSelectionChange"
            >
              <el-option
                v-for="item in deviceList"
                :key="item.deviceId"
                :label="item.deviceId"
                :value="item"
              />
            </el-select>




            <div>

     
        <div>
            <div style="width: 160px;"> 
              <!-- <el-input-number v-model="speed" size="mini" :min="1" :max="10" label="请输入调整速度1-10"></el-input-number> -->
               <el-slider v-model="speed" :min="1" :max="10" size="mini"></el-slider>
            </div>
            <div>
                <input type="button" class="btn" value="上" @click="mouseDownPTZControl(1)" @touchend="mouseUpPTZControl()"   />
                <input type="button" class="btn" value="下" @click="mouseDownPTZControl(2)" @touchend="mouseUpPTZControl()"    />
                  <input type="button" class="btn" value="调焦+" @click="mouseDownPTZControl('focalUp')" @touchend="mouseUpPTZControl()"    />
            </div>
             <div>
                   <input type="button" class="btn" value="左" @click="mouseDownPTZControl(3)" @touchend="mouseUpPTZControl()"    />
                    <input type="button" class="btn" value="右" @click="mouseDownPTZControl(4)" @touchend="mouseUpPTZControl()"   />
                    <input type="button" class="btn" value="调焦-" @click="mouseDownPTZControl('focalDown')" @touchend="mouseUpPTZControl()"    />
            </div>
        </div>
        <div>
 



        </div>

 

        <div class="preSetPointListBox">
          <div style="color: #fff;">预置点</div>
          <div style="height: 80px;overflow: scroll;">
          <div @click="preSetPointClick(item,i)" class="preSetPointListLi"
           :class="{preSetPointListLiisSet: !item.isSet,preSetPointListLiSelected: selectedPresetIndex == item.id}"
            v-for="(item,i) in preSetPointList" :key="i">
             {{item.name}} </div>
          </div>
        </div>



           <div>
             <van-button  size="mini"  @click="addPoints" class="commbtn">新增点位</van-button>
            <van-button  size="mini" @click="delPoints"  class="commbtn">删除点位</van-button>
            <van-button   size="mini" @click="getAutoLine" class="commbtn">自动识别</van-button>
            <van-button  size="mini" @click="updateDeviceProjectSubmit" class="commbtn">修改点位</van-button>
    </div>
        </div>
          </div>
    </div>

  </div>
 <!-- :show-confirm-button='false'  -->
<van-dialog v-model:show="preSetPointDialog" width="80%" title="操作预置点" :show-confirm-button='false'>
  
<div class="preSetPointDialogBTN">
  <van-button round  style="width:30%;margin:10px 0;" size="mini"   @click="preSetPointDialog = false">
  取消
</van-button>
<van-button round  style="width:30%;margin:10px 0;" size="mini"   color="linear-gradient(to right, #7bf058, #3df505)" @click="savePreSetPoint">
  保存预置点
</van-button>
<van-button v-show="preSetPointData.isSet" round  style="width:30%;margin:10px 0;" size="mini"   color="linear-gradient(to right, #ff6034, #ee0a24)" @click="getPreSetPoint">
  引用预置点
</van-button>
</div>
</van-dialog>


  </div>
</template>

<script>
import { Dialog } from 'vant';
import {  getFlowableSchoolCorxInfoList ,save,saveToo,getFlowableSchoolCorxInfoTimeList
  ,selectSchoolDeviceList,selectSchoolDeviceStatus,chooseDeviceProject,setWeekDeviceInfo,selectWeekDeviceInfo,
  selectProjectByHwp,selectConfigurationByHwp,insertConfigurationByHwp,showYTBase64} 
  from "@/api/teacher/outdoorRunning.js";


import {startHwpTC,endHwpTC,updateHwpYT,selectHwpYTPoint,selectConfigurationByHwpQd,getAutoLine,updateLine } from "@/api/teacher/cloudPlatform.js";
  
import req from '@/utils/request2.js';

  
    import moment from 'moment';
    // import mqtt from "mqtt";
    import  {fabric}  from 'fabric'
    import _ from 'lodash'
    let fabricCanvas = null
export default {
  data() {
    return {
      teacherTitleInfo:{},
      preSetPointDialog:false,
      preSetPointData:{},
      deviceList: [
        { id: 1, deviceName: '项目1', status: '结束' },
        { id: 2, deviceName: '项目2', status: '开始' },
      ],

      projectList: [
        { projectCode: "tiaotiao", projectName: '活力15' },
        { projectCode: "RopeSkippingPro", projectName: '跳绳' },
        { projectCode: "Jump", projectName: '立定跳远' },
        { projectCode: "LanQiu", projectName: '篮球拍球' },
        { projectCode: "PaiQiu", projectName: '排球颠球' },
        { projectCode: "Home", projectName: '画廊（选择项目）' },
      ],
 
      preSetPointList: [
        { id: "1", name: '起点',isSet: false },
        { id: "2", name: '终点',isSet: false },
        { id: "3", name: '预置点3',isSet: false },
        { id: "4", name: '预置点4',isSet: false },
        { id: "5", name: '预置点5',isSet: false },
        { id: "6", name: '预置点6',isSet: false },
        { id: "7", name: '预置点7',isSet: false },
        { id: "8", name: '预置点8',isSet: false },
        { id: "9", name: '预置点9',isSet: false },
        { id: "10", name: '预置点10',isSet: false },
      ],
      weekList: [
        { id: "1", name: '周一' },
        { id: "2", name: '周二' },
        { id: "3", name: '周三' },
        { id: "4", name: '周四' },
        { id: "5", name: '周五' },
        { id: "6", name: '周六' },
        { id: "7", name: '周日' },
      ],
      weekTimeList:[],
      submitData:{

      },
      selectedprojectCode:'',
      deviceData:{},
      selectedDevices: [],
      selectedDevicesObj: [], // 选中的项目对象
      selectedTimerDevice: '', // 新增：定时设置选中的项目
      timerSettings: {
        timeRanges: [
          { startTime: '', endTime: '' }
        ]
      },
      weekCheckList:[],
      configurationByHwp:[],
      ProjectByHwp:[],
      projectCodeHwpList:[],



           loading:null,
          realPlaySingle: true,
          objectHIK: {
            szIP: '192.168.0.0',
            szPort: '80',
            szUsername: 'admin',
            szPassword: 'Admin12345',
            iStreamType: 2,
            iWndIndex: 0,
            iChannelID: 1,
          },
          
          isIndeterminate: true,
          checkAll: true,
          queryCameraParams: {
            pageNum: 1,
            pageSize: 16,
            deviceType: "1"
          },
          cameras: [],
          // 总条数
          total: 0,
          checkboxGroup: [],
          realPlayGroup: [],//预览成功的摄像头
           messageList:[],
       mqtturl:'ws://192.168.50.92:8083/mqtt',
       schoolCode:"",
          mqttUserNameQd:'',
          mqttPasswordQd:'',
   
       ConfigurationByHwpQd:{
        mqtturl:'ws://192.168.50.92:8083/mqtt',
       },
       client:'',
       message: "",
       cameraList:[],
       nowStatus:'',
        tableData:[],
              listDevice:[],
              filterObj:{},
              projectCode:'',
              projectData:{},
              deviceConfigList:[],
              strokeStyleList:['#f2cac9', '#00FF00', '#0000FF', '#fffef8', '#fbda41','#fff200','#fbda41','#41ae3c'],
              BasePoints:[],
              radioLineType:'area_prepare',
            rotationAngle: 0,
             timer: null,
      isPolling: false,
      canvasImageBackGround:"",
      speed:5,
      outdoorRunnControlData:{},
      selectedPresetIndex:""
     
    };
  },
      destroyed() {

  },     
     beforeDestroy() {
            if (this.deviceData.deviceId&&this.deviceData.deviceId!=='') {
            this.endHwpTC()
            }
            if (this.client.end) this.client.end();
            //  this.stopPolling();
             Dialog.close();
        //   let objectAbc = Object.assign({}, this.objectHIK)
        //   this.$refs.hVP.clickStopRealPlay(objectAbc);
        //   this.$refs.hVP.clickLogout(objectAbc);
      },

       // 页面关闭时销毁
  beforeUnmount() {
    // this.stopPolling();
  },
         destroyed() {
         // 在需要的时候卸载监听事件，比如离开页面
        },
  computed: {
  },
  mounted () {
  
 
    //   Dialog.alert({
    //     title: '提示',
    //     message: '请横屏操作云台！',
    //   })
    //     .then(() => {
    //     })

    // 方法2：使用closeOnClickOverlay属性
    Dialog.close();
Dialog.alert({
  title: '提示',
  message: '请横屏操作云台！',
  closeOnClickOverlay: true, // 点击遮罩层可关闭
  confirmButtonText: '确定'
})
.then(() => {
  console.log('用户点击了确定');
  Dialog.close();
});
  //  this.teacherTitleInfo =  JSON.parse(sessionStorage.getItem('teacherTitleInfo'))
  //  this.getList()

this.outdoorRunnControlData = JSON.parse(localStorage.getItem("outdoorRunnControlData"))
this.getMqttInforeq()

    
        // this.show()
          fabricCanvas = new fabric.Canvas('posiToShape')
          // 限制拖动框的范围
          fabricCanvas.on('object:moving', function (e) {
          var obj = e.target;
           // if object is too big ignore如果对象太大，请忽略
  
          if(obj.currentHeight > obj.canvas.height || obj.currentWidth > obj.canvas.width){
              return;
          }        
          obj.setCoords();        
          // top-left  corner左上角
          if(obj.getBoundingRect().top < 0 || obj.getBoundingRect().left < 0){
              obj.top = Math.max(obj.top, obj.top-obj.getBoundingRect().top);
              obj.left = Math.max(obj.left, obj.left-obj.getBoundingRect().left);
          }
          // bot-right corner
          if(obj.getBoundingRect().top+obj.getBoundingRect().height  > obj.canvas.height || obj.getBoundingRect().left+obj.getBoundingRect().width  > obj.canvas.width){
              obj.top = Math.min(obj.top, obj.canvas.height-obj.getBoundingRect().height+obj.top-obj.getBoundingRect().top);
              obj.left = Math.min(obj.left, obj.canvas.width-obj.getBoundingRect().width+obj.left-obj.getBoundingRect().left);
          }
          });

          let    points= 
              [
          //       [
          //     {x: 50,y: 50, },
          //  {x: 200,y: 50, },
          //  {x: 200,y: 100, },
          //  {x: 50,y: 100, },
          // ],[
          // {x: 50,y: 50, },
          //  {x: 200,y: 50, },
          //  {x: 200,y: 100, },
          //  {x: 50,y: 100, },
          // ],
          ]
          this.initCanvas(points)

   
  },
  methods: {
     async getMqttInforeq(){
        // let data = {}
       await req.post({
          url:`${this.outdoorRunnControlData.serveIp}/getMqttInfo`,
          data:{
           areaId:this.outdoorRunnControlData.VenueId,
           projectCode:this.outdoorRunnControlData.projectCode,
          },
        }).then(res=>{
          console.log(res);
          this.schoolCode = res.body.schoolCode
          this.mqttUrl =  res.body.mqttUrl
          this.deviceList =res.data

        })
    },
      preSetPointClick(item,i){
      this.preSetPointDialog = true
      this.preSetPointData = item
    },
      handleOrientationChange() {
      setTimeout(this.checkOrientation, 100)
    },
    forceLandscape() {
      this.forceRotation = true
      this.checkOrientation()
    },
    submit(){
        if (!this.selectedDevicesObj.code||this.selectedDevicesObj.code=='') {
            return this.$toast('请选择设备！');
        }
            Dialog.confirm({
        title: '提示',
        message: '是否保存配置项？！',
        confirmButtonText: '确定',
        cancelButtonText: '取消',
      })
        .then(() => {
          this.insertConfigurationByHwp()
        })
        .catch(() => {});


    
    },
    insertConfigurationByHwp(){
            let data = {
        deviceId: this.selectedDevicesObj.code,
        relList:this.configurationByHwp,
        projectCodeList:this.projectCodeHwpList
        }
        insertConfigurationByHwp(data).then(res=>{
        this.$toast('操作成功');

        })
    },
    async selectConfigurationByHwp(){
      await  selectConfigurationByHwp({
        schoolCode: this.teacherTitleInfo.schoolCode,
        deviceId: this.selectedDevicesObj.code,
            }).then(res=>{
              console.log(res.data.body);
            this.configurationByHwp = res.data.body||[]
            this.projectCodeHwpList = []
            res.data.data.forEach(el=>{
              this.projectCodeHwpList.push(el.projectCode)
            })

            })
            selectProjectByHwp({
        schoolCode: this.teacherTitleInfo.schoolCode,
        deviceId: this.selectedDevicesObj.code,
            }).then(res=>{
              console.log(res.data.body);
            this.ProjectByHwp = res.data.body||[]

            })

    },
    async weekSelectionChange(){
      if (this.submitData.week&&this.submitData.week!=='') {
      await this.selectWeekDeviceInfo()
      }
      let weekTimeList = []
      this.weekTimeList?.forEach(item=>{
        if(item.week == this.submitData.week){
          weekTimeList.push(item)
        }
      })
          // { startTime: '', endTime: '' }
      if (weekTimeList.length==0) {
      this.$set(this.timerSettings,"timeRanges",[
          { startTime: '', endTime: '' }
        ])
        
      }else{
      this.$set(this.timerSettings,"timeRanges",weekTimeList)

      }
    },
    projectListSelectionChange(val){

    },

    chooseDeviceProject(){
      chooseDeviceProject({
        schoolCode: this.teacherTitleInfo.schoolCode,
        projectCode: this.deviceData.projectCode,
        deviceId: this.deviceData.deviceId,
            }).then(res=>{
              console.log(res);
        this.$toast('操作成功');

            })
    },
   async selectWeekDeviceInfo(){
     await selectWeekDeviceInfo({
        schoolCode: this.teacherTitleInfo.schoolCode,
        deviceId: this.deviceData.deviceId,
        week: this.submitData.week,
            }).then(res=>{
              console.log(res);
              this.weekTimeList = res.data.body
              

            })
    },
    getList(){

   

			//  ：设备类型(0,算力机;1,室外项目;2,闸机;3,查询一体机;4,大屏;5,手表,6,萌芽版)
      selectSchoolDeviceList({
        userId: this.teacherTitleInfo.teacherId,
        userName: this.teacherTitleInfo.teacherName,
        schoolCode: this.teacherTitleInfo.schoolCode,
        projectCode:"hwp"
            }).then(res=>{
              console.log(res);
              
                // this.deviceList = res.data.body
                //过滤数据

            })
        },
 
    confirmBatchPowerOn() {
      // if (!this.selectedDevices.length) {
      //   this.$toast('请先选择项目');
      //   return;
      // }
      Dialog.confirm({
        title: '提示',
        message: '确定要开启项目吗？',
        confirmButtonText: '确定',
        cancelButtonText: '取消',
      })
        .then(() => {
        })
        .catch(() => {});
    },
    
    confirmBatchPowerOff() {
      // if (!this.selectedDevices.length) {
      //   this.$toast('请先选择项目');
      //   return;
      // }
      Dialog.confirm({
        title: '提示',
        message: '确定要关闭项目吗？',
        confirmButtonText: '确定',
        cancelButtonText: '取消',
      })
        .then(() => {
        })
        .catch(() => {});
    },

    confirmSetTimer() {
      if (!this.deviceData.projectCode||this.deviceData.projectCode=='') {
        this.$toast('请先选择项目');
        return;
      }

      const valid = this.timerSettings.timeRanges.some(
        t => t.startTime && t.endTime
      );
      if (!valid) {
        this.$toast('请至少设置一个完整的时间段');
        return;
      }
      Dialog.confirm({
        title: '提示',
        message: '确定要设置定时切换项目吗？',
        confirmButtonText: '确定',
        cancelButtonText: '取消',
      })
        .then(() => {
          this.save();
        })
        .catch(() => {});
    },

    batchPowerOn() {
      console.log('批量开始', this.selectedDevices);
    },
    batchPowerOff() {
      console.log('批量结束', this.selectedDevices);
    },
    async deviceListSelectionChange(val) {
      
      this.deviceData.deviceId = val.deviceId
           if (this.deviceData.deviceId&&this.deviceData.deviceId!=='') {
            await this.endHwpTC()
            if (this.client.end) this.client.end();
            }

      this.selectedDevicesObj = val
    //  await selectSchoolDeviceStatus({ deviceId: val.deviceId,schoolCode:val.schoolCode }).then(res => {
    //     console.log("设备",res);
    //     this.deviceData = res.data.body||{}
        
    //     this.$set(this.deviceData, 'projectCode', this.deviceData.chooseProjectCode||this.deviceData.projectCode)
    //   });
    //  await this.selectConfigurationByHwp()
     await this.startHwpTC()
     await this.selectHwpYTPoint()
    //  await this.selectConfigurationByHwpQd()
       this.init()
         // 触发第一个接口
      try {
        // 触发第一个接口
        // await this.showYTBase64();
        
        // 开始轮询
        // this.startPolling();
      } catch (error) {
        console.error('接口调用失败:', error);
        // this.stopPolling();
      }
    },

    async showYTBase64(){
         try {
        const res = await showYTBase64({
          deviceId: this.deviceData.deviceId,
        });
        console.log('showYTBase64接口返回:', res);
        return res;
      } catch (error) {
        console.error('showYTBase64接口调用失败:', error);
        throw error;
      }
    },
     // 开始轮询
    startPolling() {
      this.stopPolling(); // 先清除之前的定时器
      this.isPolling = true;
      this.pollingTask();
    },
    
    // 轮询任务
    async pollingTask() {
      if (!this.isPolling) return;
      
      try {
        // 调用轮询接口
        const res = await showYTBase64({
          deviceId: this.deviceData.deviceId,
        });
        if (res.data.body) {
        this.canvasImageBackGround = `data:image/jpeg;base64,${res.data.body}` 
        }
        // res.data.body 
        console.log('轮询接口返回:', res);
        
        // 接口成功后，继续下一次轮询
        if (this.isPolling) {
          this.pollingTimer = setTimeout(() => {
            this.pollingTask();
          }, 200);
        }
      } catch (error) {
        console.error('轮询接口调用失败:', error);
        // 错误后也继续轮询（可根据需求调整）
        if (this.isPolling) {
          this.pollingTimer = setTimeout(() => {
            this.pollingTask();
          }, 200);
        }
      }
    },
    
    // 停止轮询
    stopPolling() {
      this.isPolling = false;
      if (this.pollingTimer) {
        clearTimeout(this.pollingTimer);
        this.pollingTimer = null;
      }
    },


   async startHwpTC(){
      // await  startHwpTC({
      //     deviceId: this.deviceData.deviceId,
      //     schoolCode: this.teacherTitleInfo.schoolCode,
      //     userId: this.teacherTitleInfo.teacherId,
      //     userName: this.teacherTitleInfo.teacherName,
      //   }).then(res=>{
      //     console.log(res);
      //   })

        await req.post({
          url:`${this.outdoorRunnControlData.serveIp}/startPicChannel`,
          data:{
           areaId:this.outdoorRunnControlData.VenueId,
          deviceId: this.deviceData.deviceId,
          //  projectCode:this.outdoorRunnControlData.projectCode,
          },
        }).then(res=>{
          console.log(res);
        })
    },
   async selectConfigurationByHwpQd(){
       await selectConfigurationByHwpQd({
          deviceId: this.deviceData.deviceId,
          schoolCode: this.teacherTitleInfo.schoolCode,
          userId: this.teacherTitleInfo.teacherId,
          userName: this.teacherTitleInfo.teacherName,
        }).then(res=>{
          console.log(res);
//           mqttPasswordQd: "JzyiN4HkAng4axA"
// mqttUrlQd: "ws://ua8f669b.ala.cn-hangzhou.emqxsl.cn:8084/mqtt"
// mqttUserNameQd: "vueUser"
          this.mqttPasswordQd = res.data.body.mqttPasswordQd
          this.mqttUserNameQd = res.data.body.mqttUserNameQd
          this.mqtturl = res.data.body.mqttUrlQd
            //  mqttPasswordQd: "JzyiN4HkAng4axA"
// mqttUrlQd: "ws://ua8f669b.ala.cn-hangzhou.emqxsl.cn:8084/mqtt"
// mqttUserNameQd: "vueUser" mqtturl


      this.ConfigurationByHwpQd  =res.data.body
          // this.preSetPointList = res.data.body
        })
    },
   async selectHwpYTPoint(){
      // await  selectHwpYTPoint({
      //     deviceId: this.deviceData.deviceId,
      //     schoolCode: this.teacherTitleInfo.schoolCode,
      //     userId: this.teacherTitleInfo.teacherId,
      //     userName: this.teacherTitleInfo.teacherName,
      //   }).then(res=>{
      //     console.log(res);
      //     if (res.data.body.length>0) {
      //       res.data.body.forEach(el=>{
      //         this.preSetPointList.forEach(dl=>{
      //           if (el.ptzCode == dl.id) {
      //             this.$set(dl,'isSet',true)
      //           }
      //         })
      //       })
      //     }
      //     // this.preSetPointList = res.data.body
      //   })/selecPointByDeviceId
 await req.post({
          url:`${this.outdoorRunnControlData.serveIp}/selecPointByDeviceId`,
          data:{
              // areaId:this.outdoorRunnControlData.VenueId,
             deviceId: this.deviceData.deviceId,
          //  areaId:this.outdoorRunnControlData.VenueId,
          //  projectCode:this.outdoorRunnControlData.projectCode,
          },
        }).then(res=>{
         if (res.data.length>0) {
            res.data.forEach(el=>{
              this.preSetPointList.forEach(dl=>{
                if (el.point == dl.id) {
                  this.$set(dl,'isSet',true)
                  this.$set(dl,'point',el.point)
                  this.$set(dl,'line',el.line)
                  
                }
              })
            })
          }
          console.log(res);
        })




    },
    async endHwpTC(){
        await req.post({
          url:`${this.outdoorRunnControlData.serveIp}/closePicChannel`,
          data:{
              areaId:this.outdoorRunnControlData.VenueId,
             deviceId: this.deviceData.deviceId,
          //  areaId:this.outdoorRunnControlData.VenueId,
          //  projectCode:this.outdoorRunnControlData.projectCode,
          },
        }).then(res=>{
          console.log(res);
        })
    },

// 结果输出
// {
// "commandKey":"指令唯一标识 1736930565467",
// "timestamp":1736930565467,
// "deviceId":"",
// "functionType":"1 //方向调整 2 //调整焦距 3 // 调整预置点 4 //设置预置点",
// "function":"left //方向左 right //方向右 up //方向上 down // 方向下 focalUp //增加焦距 focalDown //减少焦距 1 //预置点1 2 //预置点2 3 //预置点3 "
    async savePreSetPoint(){
      if (!this.deviceData.deviceId||this.deviceData.deviceId=='') {
        this.$toast('请先选择设备');
        return
      }
      this.speed = 5
      await this.updateHwpYT("4",this.preSetPointData.id)
      // 更新预置点
      await this.selectHwpYTPoint()
      this.preSetPointDialog = false

    },
    async getPreSetPoint(){
      if (!this.deviceData.deviceId||this.deviceData.deviceId=='') {
        this.$toast('请先选择设备');
        return
      }
      await this.updateHwpYT("3",this.preSetPointData.id)
      this.preSetPointDialog = false

    },
    
    async updateHwpYT(functionType,functionv){
      //  await updateHwpYT({
      //     deviceId: this.deviceData.deviceId,
      //     schoolCode: this.teacherTitleInfo.schoolCode,
      //     userId: this.teacherTitleInfo.teacherId,
      //     userName: this.teacherTitleInfo.teacherName,
      //     speed:this.speed,
      //     functionType:functionType,
      //     function:functionv
      //   }).then(res=>{
      //     console.log(res);
      //   })

    await req.post({
          url:`${this.outdoorRunnControlData.serveIp}/panTiltFunction`,
          data:{
            deviceId: this.deviceData.deviceId,
          speed:this.speed.toString(),
          functionType:functionType,
          function:functionv

          //  areaId:this.outdoorRunnControlData.VenueId,
          //  projectCode:this.outdoorRunnControlData.projectCode,
          },
        }).then(res=>{
        if (res.status=="00") {
        this.$toast('操作成功');
        if (functionType==3) {

          let lineData = []
            if (this.preSetPointData?.line&&this.preSetPointData?.line.length>0) {
               lineData = this.preSetPointData.line
               console.log(lineData);
               
              this.LineUpData(lineData)
            }else{
              this.LineUpData(lineData)
            }
        // 引用预置点
        this.selectedPresetIndex = this.preSetPointData.id
        }
          }else{
        this.$toast(res.msg);
          }


          console.log(res);
        })


    },





    save() {
      console.log('设置定时', {
        deviceId: this.selectedTimerDevice,
        timeRanges: this.timerSettings.timeRanges
      });
   
			// flowableSchoolCorxTime：[{
			//     id：定时记录ID
			//     corxCode ：设备编码
			//     week：星期（1,2,3,4,5,6,7）
      // week: this.weekCheckList
			//     startTime ：开始时间
			//     endTime ：截止时间
			// }],
      let weekList = []

      if (this.timerSettings.timeRanges.length > 0) {
        this.timerSettings.timeRanges.forEach((item, index) => {
          weekList.push({
            projectCode: item.projectCode,
            week: this.submitData.week,
            startTime: item.startTime,
            endTime: item.endTime,
          });
        });
      } else {
        this.$toast('请至少设置一个完整的时间段');
        return;
      }
      let data = {
        deviceId: this.deviceData.deviceId,
        schoolCode: this.teacherTitleInfo.schoolCode,
        weekTimeList:weekList,
      }
      setWeekDeviceInfo(data).then(res => {

        this.$notify({ type: "success", message: '操作成功' })

        // this.timerSettings.timeRanges=[
        //   { startTime: '', endTime: '' }
        // ]
        // this.selectedTimerDevice = ''
      });
    },
    addTimeRange() {
      this.timerSettings.timeRanges.push({ startTime: '', endTime: '' });
    },
    removeTimeRange(idx) {
      this.timerSettings.timeRanges.splice(idx, 1);
    },
    // handleSelectionChange(val) {
    //   this.selectedDevices = val.slice();
    // },
    getRowKey(row) {
      return row.id;
    },


// -----------------------------------------------------------------------
// 结果输出
// {
// "commandKey":"指令唯一标识 1736930565467",
// "timestamp":1736930565467,
// "deviceId":"",
// "functionType":"1 //方向调整 2 //调整焦距 3 // 调整预置点 4 //设置预置点",
// "function":"left //方向左 right //方向右 up //方向上 down // 方向下 focalUp //增加焦距 focalDown //减少焦距 1 //预置点1 2 //预置点2 3 //预置点3 "
     mouseDownPTZControl(type){
          // 开始
          console.log('mouseDownPTZControl');
    if (!this.deviceData.deviceId||this.deviceData.deviceId=='') {
        this.$toast('请选择设备！');
        return
    }
    let functionType = '';
    let functionValue = '';

    // 方向控制 (functionType = 1)
    if ([1, 2, 3, 4, 5, 6, 7, 8].includes(type)) {
      functionType = '1';
      const directionMap = {
        1: 'up',
        2: 'down',
        3: 'left',
        4: 'right',
        5: 'left+up',
        6: 'left+down',
        7: 'right+up',
        8: 'right+down'
      };
      functionValue = directionMap[type] || '';
    }
    // 焦距控制 (functionType = 2)
    else if (type === 'focalUp') {
      functionType = '2';
      functionValue = 'focalUp';
    } else if (type === 'focalDown') {
      functionType = '2';
      functionValue = 'focalDown';
    }

    // 调用接口
    this.updateHwpYT(functionType, functionValue);
          
        },
        mouseUpPTZControl(){
          // 结束
        },

   // 初始化
   initMqtt(){
        this.messageList = []
      let vm = this;
      let commonApi = `${vm.mqtturl}`;
      // var mqtt = mqtt;
      var options = {
        //mqtt客户端的id
        clientId: "mqttjs_" + Math.random().toString(16).substr(2, 8),
        username: vm.mqttUserNameQd,
        password: vm.mqttPasswordQd
      };

      vm.client = mqtt.connect(commonApi, options);
      console.log('xxxxx事实上事实上少时诵诗书xxxxxxxxxxxx嘻嘻嘻嘻嘻嘻嘻嘻嘻嘻嘻嘻嘻嘻嘻',vm.client);
      vm.client.on("connect", function () {
        vm.messageList.push('连接成功....')
        console.log("连接成功....");
       vm.mqttReceive();

      });
      //如果连接错误，打印错误
      vm.client.on("error", function (err) {
        vm.messageList.push('连接失败....' + err)

        console.log("err=>连接失败", err);
        vm.client.end();
      });
    },
     /**
     * @name:发布mqtt消息
     */
    mqttPublish(val) {
      let topic = "topic/ykq"; //和后台约定好的主题
      let message = ''
      switch (val) {
        case 'left': message = '左滑';break;
        case 'right': message = '右滑';break;
        case 'joinProject': message = '进入';break;
        case 'exitProject': message = '结束';break;
        default:
            break;
      }
      this.messageList.push('操作：' + message)
      this.client.publish(topic, val);
    },
     /**
     * @name:接收mqtt消息
     */
    mqttReceive() {
      
      let topic1 = `dev/${this.schoolCode}/picChannel`; // 获取图片
      // let topic1 = `dev/LMWZ/picChannel`; // 获取图片
      let topic2 = "client/dev/report/sport/chooseProject"; //项目编码
      let topic3 = "client/dev/report/sport/lineUpPerson"; //人员上场
      let topic4 = "client/dev/report/sport/test"; //测试信息
      let topic5 = "client/dev/report/sport/startend"; //1：开始  2：结束
      console.log("topic1",topic1);
      
      const vm = this;
      vm.client.subscribe([topic1, topic2, topic3,topic4,topic5], function (err) {
        if (!err) {
          console.log("subscribe success!");
        } else {
          //打印错误
          console.log("err", err);
        }
      });
      vm.client.on("message", function (topic, message) {
        let messageData = JSON.parse(message.toString())

        switch (topic) {
          case topic1:
            // console.log("topic1", topic, message.toString(),messageData);
            vm.canvasImageBackGround = `data:image/jpeg;base64,${messageData.base64}` 
            break;
        
        
          case topic5:
            // console.log("topic2", topic, message.toString());
            if (+messageData.overTest==2) {
            vm.testParamList = []
            }
            vm.overTest = messageData.overTest
            break;
        }
        
      });
    },
   
    init(){
     
        if (this.mqtturl) {
       this.initMqtt();
        }

    },


      // 新增人数点位
      addPoints(){
         if (this.selectedPresetIndex=='') {
          this.$notify({ type: "warning", message: '请先引用预置点！' });
          return
         }
         this.BasePoints.push([
           {x: 50,y: 50, },
           {x: 200,y: 50, },
           {x: 200,y: 100, },
           {x: 50,y: 100, },
         ])
         this.initCanvas(this.BasePoints)
 
       },
       delPoints(){
 // 判断当前有没有选中元素，如果没有就不执行任何操作
  if (this.selectedPresetIndex=='') {
          this.$notify({ type: "warning", message: '请先引用预置点！' });
          return
         }
 if (!fabricCanvas.getActiveObject()) {
  this.$notify({ type: "warning", message: '请选择要操作的点位信息！' });
     return
   }
 
   // 判断当前是否选中组，如果不是，就不执行任何操作
   if (fabricCanvas.getActiveObject().type !== 'group') {
     return
   }
 
   // 先获取当前选中的对象，然后打散
   fabricCanvas.remove(fabricCanvas.getActiveObject())
       },
 
    //  改变摄像头焦距
    setPresets(){
      
      MessageBox.confirm('此操作将摄像头焦距, 是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(()=>{
            let data =  this.setPresetsData
            baseData.aifacePostv2(
            `/hikvisionSdkRule/setPresets?username=${data.username}&username=${data.password}&ip=${data.ip}&point=${data.point}&distortion=${data.distortion}`,
            data,
            (r) => {
            }
          );
          })
  
  
    
        },
        LineUpData(line){
                const width = 512;
                const height = 288;
                if (Array.isArray(line)) {
                  this.BasePoints = line.map(poly => {
                    const [x1, y1, x2, y2, x3, y3, x4, y4] = poly;
                    return [
                      { x: Math.round(x4 * width), y: Math.round(y4 * height) },  // 左上
                      { x: Math.round(x1 * width), y: Math.round(y1 * height) }, // 左下
                      
                      { x: Math.round(x2 * width), y: Math.round(y2 * height) }, // 右下
                      { x: Math.round(x3 * width), y: Math.round(y3 * height) }, // 右上
                    ];
                  });
                }

                this.initCanvas(this.BasePoints);
        },
        getAutoLine(){
             if (!this.deviceData.deviceId||this.deviceData.deviceId=='') {
        this.$toast('请选择设备！');
        return
    }
          getAutoLine({
             deviceId: this.deviceData.deviceId,
          }).then(res=>{
            console.log("guodianxixnix",res.data.body.line);
            if (res.data.body?.line.length>0) {
              let lineData = res.data.body.line
              this.LineUpData(lineData)

           

            }
            
          }).catch(err=>{

          //  let data =  {"status":"00","msg":null,"data":null,"obj":null,"body":{"deviceId":"W6IYSXdeACMRTLZo","line":[[0.7892632484436035,0.7561752319335937,0.9414955139160156,0.761936526828342,0.9273019790649414,0.7380841573079427,0.777062177658081,0.7290617201063369],[0.6389284610748291,0.7504858228895399,0.7892632484436035,0.7561752319335937,0.777062177658081,0.7290617201063369,0.629209566116333,0.7203676859537761],[0.48889951705932616,0.7448080274793837,0.6389284610748291,0.7504858228895399,0.629209566116333,0.7203676859537761,0.4823460102081299,0.7120987786187066],[0.3404503345489502,0.7391899956597222,0.48889951705932616,0.7448080274793837,0.4823460102081299,0.7120987786187066,0.3379871129989624,0.7047450171576606],[0.18844224214553834,0.7334371778700087,0.3404503345489502,0.7391899956597222,0.3379871129989624,0.7047450171576606,0.19038851261138917,0.6988877614339193],[0.03893207013607025,0.7277789645724826,0.18844224214553834,0.7334371778700087,0.19038851261138917,0.6988877614339193,0.04510839283466339,0.6948385874430338]],"msg":"","picType":null,"status":"00"},"obj1":null,"resultMap":null,"total":0,"wxLoginStatus":0,"msgList":[]}
          //   console.log(data.body);
            
          //  if (data.body?.line.length>0) {
          //     let lineData = data.body.line


          //      const width = 512;
          //       const height = 288;


          //       if (Array.isArray(lineData)) {
          //         this.BasePoints = lineData.map(poly => {
          //           const [x1, y1, x2, y2, x3, y3, x4, y4] = poly;
          //           return [
          //             { x: Math.round(x4 * width), y: Math.round(y4 * height) },  // 左上
          //             { x: Math.round(x1 * width), y: Math.round(y1 * height) }, // 左下

          //             { x: Math.round(x2 * width), y: Math.round(y2 * height) }, // 右下
          //             { x: Math.round(x3 * width), y: Math.round(y3 * height) }, // 右上
          //           ];
          //         });
          //       }

          //       this.initCanvas(this.BasePoints);

          //   }
         
          })
        },

        // 修改设备点位信息
        updateDeviceProjectSubmit(){
          if (this.selectedPresetIndex=='') {
          this.$notify({ type: "warning", message: '请先引用预置点！' });
          return
         }
        let vm = this
        let points = []
        // console.log(fabricCanvas,'fabricCanvas');
  
        // let items = fabricCanvas.getObjects();
        let items = fabricCanvas._objects;
        
          if (items.length==0) {
                    this.$toast('暂无点位信息！');

            return
          }
          
  
        items.forEach((item, index) => {
                   console.log("item",item);
                   
                      if (item.oCoords.p0) {
                      // 移动了框框
                      // let oCoordsPoints = Object.values(item.oCoords).map(mapItem=>{return {x:mapItem.x,y:mapItem.y}})
                      // points.push(oCoordsPoints)


                      const oCoords = item.oCoords;

                    // 显式按语义取点（根据你提供的 p0~p3 含义）
                    const topLeft = oCoords.p0;     // 左上
                    const bottomLeft = oCoords.p1;  // 左下
                    const bottomRight = oCoords.p2; // 右下
                    const topRight = oCoords.p3;    // 右上

                    // 按 [左下, 右下, 右上, 左上] 顺序组织
                    const orderedPoints = [
                      { x: bottomLeft.x, y: bottomLeft.y },   // 左下
                      { x: bottomRight.x, y: bottomRight.y }, // 右下
                      { x: topRight.x, y: topRight.y },       // 右上
                      { x: topLeft.x, y: topLeft.y }          // 左上
                    ];

                    points.push(orderedPoints);



                      }else{
                      // 没移动框框
                      points.push(item.points)
                      }
                        // points.push(item.points)
  
        });



        console.log(points,'points');

       const width = 512;
        const height = 288;

        const line = points.map(quad => {
          const [tl, bl, br, tr] = quad; // tl=左上, bl=左下, br=右下, tr=右上
          return [bl, br, tr, tl].flatMap(p => [p.x / width, p.y / height]);
        });

        console.log("line:", line);




   



        let data =  
          {
            deviceId: this.deviceData.deviceId,
            line:line,
            point:this.preSetPointData.point
          }
        // this.projectData
      
           Dialog.confirm({
        title: '提示',
        message: '确定要保存此设置吗？',
        confirmButtonText: '确定',
        cancelButtonText: '取消',
      })
        .then(() => {

          this.updateLine(data)

        })
        .catch(() => {});

        },
       
       async updateLine(data){
          await req.post({
          url:`${this.outdoorRunnControlData.serveIp}/updateLine`,
          data:data,
        }).then(res=>{
        if (res.status=="00") {
          // 更新划线数据
          this.preSetPointList.forEach(el=>{
            if (el.point == this.preSetPointData.point) {
              this.$set(el,'line',data.line)
            }
          })
           this.$set(this.preSetPointData,'line',data.line)

        this.$toast('操作成功');
          }else{
        this.$toast(res.msg);
          }
          console.log(res);
        })
        },

         
    
    
        async onfilterObjProject(val){
          
          // objectHIK.szIP
          let xcanvas = 512
          let ycanvas = 288
          // 清除绘图
          // let myCanvas = document.querySelector('#posiToShape');
          // let ctx = myCanvas.getContext("2d");
          // ctx.clearRect(0, 0, xcanvas, ycanvas)
    
         let projectData =  this.tableData.find((el) => {
            return el.dataId == val
          })
          console.log(JSON.parse(projectData.line),'line');
    
          this.projectData = projectData
          // 配置信息获取摄像头ip
          let deviceConfig =  this.deviceConfigList.find((el) => {
            return el.deviceSign == projectData.deviceSign
          }) ||{}
          console.log('deviceConfig',deviceConfig);
  
          // 如果ip不变不更新预览
          if (deviceConfig.lanIp == this.objectHIK.szIP) {
            
          }else{
          // 如果ip改变更新预览
          let objectAbc = Object.assign({}, this.objectHIK)
           this.$set(this.objectHIK, 'szIP', deviceConfig.lanIp||'')
           this.$set(this.objectHIK, 'szUsername', deviceConfig.account||'admin')
           this.$set(this.objectHIK, 'szPassword', deviceConfig.pwd||'Admin12345')
  
  
           let newobjectAbc = Object.assign({}, this.objectHIK)
           this.$refs.hVP.changeIPS(objectAbc,newobjectAbc);
    
          }
          
          
    
    
          let points = []
          let area = JSON.parse(this.projectData.line).area
          if (this.projectData.projectCode=='FiftyMetersrun50mvice'||this.projectData.projectCode=='HundredMetersrun100mvice') {
            // 50米起点单独处理  100米起点单独处理
            area = JSON.parse(this.projectData.line).area_vice
          }
          area.forEach((item,i)=>{
            // JSON.parse(this.projectData.line).forEach((item,i)=>{
            let lineList = item.scale
            let pointsObj = []
            lineList.forEach(el=>{
                pointsObj.push({x:el[0] * xcanvas,y:el[1] * ycanvas}) 
              // el[0] = el[0] * xcanvas
              // el[1] = el[1] * ycanvas
            })
            points.push(pointsObj)
    
     
          })
  
          console.log('points',points);
         this.BasePoints = JSON.parse(JSON.stringify(points))
          
          // fabricCanvas.requestRenderAll()
          // points= 
          //     [[
          //   {x: 0,y: 0, },
          //   {x: 420,y: 0, },
          //   {x: 420,y: 315, },
          //   {x: 100,y: 400, },
          //   {x: 0,y: 315, },
          // ],[
          //   {x: 0,y: 200, },
          //   {x: 200,y: 200, },
          //   {x: 200,y: 200, },
          //   {x: 0,y: 315, },
          // ],
          // ],
          
              // 掉后台接口改变焦距
    this.setPresetsData = {
      username:deviceConfig.szUsername,
      password:deviceConfig.szPassword,
      ip:deviceConfig.lanIp,
      point:projectData.point,
      distortion:projectData.isdistortion,
    }
    // this.setPresets(setPresetsData)
     },
    
  
     
          onfilterObjSubmit(){
            console.log(this.filterObj);
            this.projectCode = ''
          this.$set(this.filterObj, 'projectCode', '')
    
        },
    
      
     
    
    show () {
    this.$nextTick(_ => {
    let customCanvas =this.$refs.canvas;// canvas显示层
    this.customcxt = customCanvas.getContext("2d");
    })
    
    },
    
    
        //  画线
        
        
    
          GETcanvasData(){
        console.log('fabricCanvas', fabricCanvas.getObjects())
        let points = []
          let items = fabricCanvas.getObjects();
                    items.forEach((item, index) => {
                      let itemcoord = {}
                      console.log(item,'item');
                      
                        if (item.oCoords.p0) {
                        // 移动了框框
                        let oCoordsPoints = Object.values(item.oCoords).map(mapItem=>{return {x:mapItem.x,y:mapItem.y}})
                        points.push(oCoordsPoints)
                       
                        }else{
                        // 没移动框框
                        points.push(item.points)
                        }
                        
                        // points.push(itemcoord)
        });
        console.log('points',points);
      },  
        initCanvas  (item)  {
          // 直接获取Dom
          //  if (fabricCanvas!==null) {
          fabricCanvas.clear()
          // fabricCanvas.renderAll();
          // }
          // 创建一个矩形数组，上面
          let points = JSON.parse(JSON.stringify(item))
          console.log(points,'points');
          for (let i = 0; i < points.length; i++) {
            const element = points[i];
            var polygon2 = null
            console.log('element',element);
  
       
            
            // 没有文字-------------------------------------------------------
        //     fabricCanvas.add(new fabric.Polygon(element, {
        //   // left:0,
        //   // top:0,
        //   fill: '#D81B60',
        //   // strokeWidth: 1,
        //   stroke: 'green',
        //   // scaleX: 0,
        //   // scaleY: 0,
        //   objectCaching: false,
        //   transparentCorners: false,
        //   cornerColor: 'blue',
        // }))
            // 没有文字-------------------------------------------------------
  
  
            // 创建一个多边形
          let polygon = new fabric.Polygon(element, {
            // left:0,
            // top:0,
            // fill: '#6df13086',
            fill: '#6df13086',
            // opacity: 0.8,
            strokeWidth: 1,
            stroke: 'green',
            // scaleX: 0,
            // scaleY: 0,
            objectCaching: false,
            transparentCorners: false,
            cornerColor: 'blue',
           
          })
  // // 设置控制点
  // polygon.setControlsVisibility({
  //     mt: true, // middle top
  //     mb: true, // middle bottom
  //     ml: true, // middle left
  //     mr: true, // middle right
  //     bl: true, // bottom left
  //     br: true, // bottom right
  //     tl: true, // top left
  //     tr: true, // top right
  //     mtr: false // 旋转控制点
  // });
          // console.log('element',element);
          //   // 创建中心文本
          const text = new fabric.Text(String(i+1), {
              fontSize: 28,
              fill: "#fff",
              // left:0,
              // top:0,
              top: element[0].y,
              left: element[0].x,
        
  
            });
            let fabricGroup = []
            fabricGroup = [polygon, text]
          // // // /合并需要绘制的内容
            let group = new fabric.Group(
              fabricGroup,
              {
                objectCaching: false,
              }
            );
  
            
            // 禁止旋转
            group.lockRotation = true
            group.cornerStyle = 'circle'
            fabricCanvas.selection = false // 不允许直接从画布框选
            fabricCanvas.add(group)
            // this.Editmodule(fabricCanvas.getObjects()[i])
          }
  
          this.Edit()
        },
  
  
    
      
    //定义一个可以定位控件的函数。
    //此函数将用于绘图和交互。
         polygonPositionHandler(
          dim,
          finalMatrix,
          fabricObject,
          constrol
        ) {
          const index = constrol.pointIndex
          var x = fabricObject.points[index].x - fabricObject.pathOffset.x,
            y = fabricObject.points[index].y - fabricObject.pathOffset.y
          return fabric.util.transformPoint(
            { x: x, y: y },
            fabric.util.multiplyTransformMatrices(
              fabricObject.canvas.viewportTransform,
              fabricObject.calcTransformMatrix()
            )
          )
        },
    
     //定义一个函数来定义控件的功能
    //每次鼠标移动控件后都会调用这个函数
    //被点击并被拖动。
    //函数接收鼠标事件作为参数，即当前变换对象
    //和当前在画布坐标中的位置
    //转换。Target是对正在转换的当前对象的引用，
         actionHandler  (eventData, transform, x, y) {
          var polygon = transform.target,
            currentControl = polygon.controls[polygon.__corner],
            mouseLocalPosition = polygon.toLocalPoint(
              new fabric.Point(x, y),
              'center',
              'center'
            ),
            polygonBaseSize = polygon._getNonTransformedDimensions(),
            size = polygon._getTransformedDimensions(0, 0),
            finalPointPosition = {
              x:
                (mouseLocalPosition.x * polygonBaseSize.x) / size.x +
                polygon.pathOffset.x,
              y:
                (mouseLocalPosition.y * polygonBaseSize.y) / size.y +
                polygon.pathOffset.y,
            }
          polygon.points[currentControl.pointIndex] = finalPointPosition
          return true
        },
    //定义一个函数，当我们改变它的位置时，它可以使多边形保持在相同的位置
    //宽度/高度/ /左。
    anchorWrapper(anchorIndex, fn)  {
          return function (eventData, transform, x, y) {
            var fabricObject = transform.target,
              absolutePoint = fabric.util.transformPoint(
                {
                  x: fabricObject.points[anchorIndex].x - fabricObject.pathOffset.x,
                  y: fabricObject.points[anchorIndex].y - fabricObject.pathOffset.y,
                },
                fabricObject.calcTransformMatrix()
              ),
              actionPerformed = fn(eventData, transform, x, y),
              // newDim = fabricObject._setPositionDimensions({}),
              polygonBaseSize = fabricObject._getNonTransformedDimensions(),
              newX =
                (fabricObject.points[anchorIndex].x - fabricObject.pathOffset.x) /
                polygonBaseSize.x,
              newY =
                (fabricObject.points[anchorIndex].y - fabricObject.pathOffset.y) /
                polygonBaseSize.y
            fabricObject.setPositionByOrigin(absolutePoint, newX + 0.5, newY + 0.5)
            return actionPerformed
          }
        },
    
        Edit ()  {
        //你在复制什么
  //可能需要复制粘贴在不同的时刻。
  //如果您不希望更改发生
  //稍后对副本进行反思。
            let vm = this
            let polyArr = fabricCanvas.getObjects()
        console.log('fabricCanvas', fabricCanvas.getObjects(),polyArr.length)
        if (polyArr.length<=0) {
            return
          }
          for (let index = 0; index < polyArr.length; index++) {
            const poly = polyArr[index];
            poly.points = poly._objects[0].points
            poly.pathOffset = poly._objects[0].pathOffset
            
        fabricCanvas.setActiveObject(poly)
        poly.edit = !poly.edit
  
        console.log('poly',poly);
        if (poly.edit) {
          var lastControl = poly.points.length - 1
          poly.cornerStyle = 'circle'
          poly.cornerColor = 'rgba(0,0,255,0.5)'
          poly.controls = poly.points.reduce(function (acc, point, index) {
            const control = new fabric.Control({
              positionHandler: (a, b, c) =>
                vm.polygonPositionHandler(a, b, c, control),
              actionHandler: vm.anchorWrapper(
                index > 0 ? index - 1 : lastControl,
                vm.actionHandler
              ),
              actionName: 'modifyPolygon',
              pointIndex: index,
            })
            acc['p' + index] = control
            return acc
          }, {})
        } else {
          poly.cornerColor = 'blue'
          poly.cornerStyle = 'rect'
          poly.controls = fabric.Object.prototype.controls
        }
        poly.hasBorders = !poly.edit
          }
        // var poly = fabricCanvas.getObjects()[0]
        // 强制重新渲染
        fabricCanvas.requestRenderAll()
        
      }

  },
};
</script>


<style lang="less" scoped>
.power-switch-page {
//  width: 100vw;
//   height: 100vh;
   position: fixed;
  top: 0;
  left: 0;
  overflow: hidden;

padding: 10px;

  // background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  background: linear-gradient(135deg, #667eea 0%, #a48cbd 100%);



  .bodybox{

//   transform-origin: center center;
  width: 100%;
  height: 100%;
  display: flex;

  /* 强制横屏 */
//   transform: rotate(90deg);
//   transform-origin: center center;
//   position: fixed;
//   top: 0;
//   left: 0;



  }

    .leftbox{
        width: 80%;
        min-width: 600px;
        // display: flex;
        // justify-content: center;
    }
    .rightbox{
        width: 20%;
        min-width: 200px;
  overflow: scroll;
  .commbtn{
     width: 70px;
                height: 20px;
                line-height: 20px;
    margin: 0px;
    margin-right: 10px;
  }
        // display: flex;
        // justify-content: center;
             .btn{
                width: 48px;
                height: 20px;
                line-height: 20px;
                text-align: center;
                // background-color: #fff;
                border: 1px solid #fff;
                background-color: #fff;
                margin: 0px;
                margin-right: 10px;
                margin-bottom: 5px;
                padding: 0;
                font-size: 10px;
            }
    }
}
.preSetPointListBox{
  font-size: 10px;
  
  .preSetPointListLi{
    background-color: #fff;
    width: 160px;
    margin: 3px 0;
    padding: 3px;
    text-align: center;
    font-size: 10px;
    height: 15px;
    line-height: 15px;
  }
  .preSetPointListLiisSet{
    background-color: #bcbdc0;
    color: #fff;
  }
  .preSetPointListLiSelected{
    border: 2px solid #f80606;
  }
}
.preSetPointDialogBTN{
  display: flex;
  // align-items: center;
  justify-content: center;
  // justify-items: center;
}
.page-card {
//   max-width: 800px;
//   margin: 0 auto;
// background-color: #fff;
// padding: 10px;
//   border-radius: 6px;
}

.card-header {
//   padding: 10px 0;
}

.deviceBox{
  font-size: 12px;
  .deviceBox_li{
    display: flex;
    line-height: 35px;
  }
}
.page-title {
  font-size: 18px;
  font-weight: 600;
  color: #303133;
  text-align: center;
  margin: 0;
}

.content-section {
  margin-bottom: 20px;
}

.custom-table {
//   box-shadow: 0 2px 12px 0 rgba(0,0,0,.05);
}

.control-panel {
  /* background: #f8f9fb; */
  padding: 15px;
  border-radius: 6px;
  margin-bottom: 15px;
  text-align: center;
}

.panel-title {
  font-size: 14px;
  color: #606266;
  margin-bottom: 12px;
  text-align: center;
}

.action-buttons {
  display: flex;
  justify-content: center;
  gap: 20px;
}

.timer-section {
//   background: #f8f9fb;
  padding: 15px;
  border-radius: 6px;
}

.timer-form {
  max-width: 400px;
  margin: 0 auto;
}

.time-picker {
  width: 160px;
}

.form-button {
  text-align: center;
  margin-top: 20px;
}

.device-select-row {
  margin-bottom: 10px;

}

.timer-range-row {
  /* display: flex; */
  /* align-items: center; */
  gap: 10px;
  margin-bottom: 8px;
}

.remove-range-btn {
  margin-left: 8px;
}

  #data-view {
      width: 100%;
      height: 100%;
      text-align: center;
      padding: 0px;
    
      // background: linear-gradient(180deg, #1D1F45 12%, #33397D 100%);
 
    .elPageHeader {
      margin-bottom: 10px;
      
    }
    
    
    
    .main-plugin{
      position: relative;
    //   width: 512px;
    //   height: 288px;
    //   margin: 0px auto;
        background-color: #67b9df;
    }
     .main-canvas{
        position: absolute;
        top: 0;
        left: 0;
        padding: 0;
        margin: 0;
        z-index: 10;
        border: 1px solid #ccc;
    }
    
    }
</style>